import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BlurredAztecCode } from '../../../atoms/BlurredAztecCode/BlurredAztecCode';

import {
	MplDeutschlandTicketCardHeader,
	MplDeutschlandTicketCardSeparator,
	MplDeutschlandTicketNameAndStatus,
	StyledBottomContainer,
	StyledCardContainer,
	StyledTicketContainer,
	StyledTicketDetailsSection,
} from './components';

interface IMplDeutschlandTicketCardPendingProps {
	firstName: string;
	lastName: string;
	formattedPrice: string;
}

export const MplDeutschlandTicketCardPending: FC<
	IMplDeutschlandTicketCardPendingProps
> = ({ firstName, lastName, formattedPrice }) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledTicketContainer>
			<StyledCardContainer>
				<MplDeutschlandTicketCardHeader formattedPrice={formattedPrice} />
				<MplDeutschlandTicketCardSeparator />
				<StyledBottomContainer>
					<StyledTicketDetailsSection>
						<MplDeutschlandTicketNameAndStatus
							firstName={firstName}
							lastName={lastName}
							statusText={t('dticket_large.status.in_processing')}
							statusVariant="info"
						/>
					</StyledTicketDetailsSection>
					<BlurredAztecCode />
				</StyledBottomContainer>
			</StyledCardContainer>
		</StyledTicketContainer>
	);
};
